<div class="modal-header d-flex align-items-center">
  <h5 class="zero-text p-big-bold">{{ headline }}</h5>
  @if (dismissable) {
    <web-design-system-icon data-zid="popup-close" name="cross" (click)="dismiss.emit()" aria-label="Close" class="cursor-pointer" />
  }
</div>
<div class="modal-body">
  <ng-content />
</div>
